import React, { useState } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Box,
  Typography,
  Switch,
  Avatar,
  Divider,
  Button
} from "@material-ui/core/"
// import { closeShareWithPartnerDialog } from "actions/share-with-partner-dialog"
import cloudinary from "cloudinary-core"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})
const ShareWithPartnerDialog = ({
  classes,
  partners,
  sharePartners,
  setSharePartners,
  org,
  changeButton,
  setChangeButton
}) => {
  const currentOrgId = org.id
  const handlePartnerShare = (id, index) => {
    let updatedPartners = sharePartners

    if (updatedPartners.length && updatedPartners.includes(id)) {
      updatedPartners = updatedPartners.filter(partner => partner !== id)
    } else {
      updatedPartners.push(id)
    }
    let rename = index => {
      return index
    }
    setChangeButton(oldState => ({
      ...oldState,
      [rename(index)]: !changeButton[index]
    }))
    setSharePartners(updatedPartners)
  }

  const acceptedPartners = () => {
    return partners.filter(partner => partner.accepted === 1).length
  }
  const partnerAddres = address => {
    let initialPartnerAddress = ""
    if (address) {
      try {
        initialPartnerAddress =
          JSON.parse(address).city + ", " + JSON.parse(address).state
      } catch (err) {
        console.log(err)
      }
    }
    return initialPartnerAddress
  }

  const requesterAddress = address => {
    let initialRequesterAddress = ""
    if (address) {
      try {
        initialRequesterAddress =
          JSON.parse(address).city + ", " + JSON.parse(address).state
      } catch (err) {
        console.log(err)
      }
    }
    return initialRequesterAddress
  }

  return (
    <Box>
      <Typography className={classes.title}>
        Select other Fistline Social organizations
      </Typography>
      <Box className={classes.tagContainer}>
        {partners.length && acceptedPartners() ? (
          partners
            .filter(partner => partner.accepted === 1)
            .map((partner, index) => {
              return partner ? (
                <Box key={index}>
                  <Box display="flex" justifyContent="space-between">
                    <Box display="flex" className={classes.leftContainer}>
                      <Avatar
                        className={classes.avatarContainer}
                        src={
                          partner.partner_id === org.id
                            ? partner.requester_logo &&
                              cl.url(
                                JSON.parse(partner.requester_logo).public_id,
                                {
                                  width: 150,
                                  crop: "scale"
                                }
                              )
                            : partner.partner_logo &&
                              cl.url(
                                JSON.parse(partner.partner_logo).public_id,
                                {
                                  width: 150,
                                  crop: "scale"
                                }
                              )
                        }
                      />
                      <Box display="flex" flexDirection="column">
                        <Typography variant="h5" className={classes.name}>
                          {partner.partner_id === org.id
                            ? partner.requester_name
                            : partner.partner_name}
                        </Typography>
                        <Typography variant="h6" className={classes.address}>
                          {partner.partner_id === org.id
                            ? partnerAddres(partner.requester_address)
                            : requesterAddress(partner.partner_address)}
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      className={
                        changeButton[index]
                          ? classes.selectedButton
                          : classes.selectButton
                      }
                      variant={changeButton[index] ? "contained" : "outlined"}
                      color="primary"
                      onClick={
                        currentOrgId === partner.org_id
                          ? () => handlePartnerShare(partner.partner_id, index)
                          : () => handlePartnerShare(partner.org_id, index)
                      }
                    >
                      {changeButton[index] ? "Selected" : "Select"}
                    </Button>
                    {/* <Box display="flex" className={classes.rightContainer}>
                    <Switch
                      value="checkedD"
                      color="primary"
                      inputProps={{ "aria-label": "disabled checkbox" }}
                      onChange={
                        currentOrgId === partner.org_id
                          ? () => handlePartnerShare(partner.partner_id)
                          : () => handlePartnerShare(partner.org_id)
                        // setSwitchValue(!switchValue)
                      }
                    />
                    <Box display="flex" alignItems="center">
                      <Typography>Share</Typography>
                    </Box>
                  </Box> */}
                    {}
                  </Box>
                  <Divider className={classes.divider} />
                </Box>
              ) : (
                ""
              )
            })
        ) : (
          <Box>
            <Typography variant="h3" className={classes.noPartnersText}>
              No Partners
            </Typography>
            <Typography className={classes.noPartnersText}>
              You can add partners in the organizations tab.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const mapStateToProps = state => {
  return {
    open: state.shareWithPartnerDialog.open,
    partners: state.organization.currentOrg.partners,
    org: state.organization.currentOrg
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withMobileDialog()
)(ShareWithPartnerDialog)



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/ShareWithPartner/index.jsx